import { distance, getBBoxByArray } from './util';
import * as vec2 from 'gl-matrix/vec2';
export default {
    /**
     * è®¡ç®çº¿æ®µçåå´ç
     * @param {number} x1 èµ·å§ç¹ x
     * @param {number} y1 èµ·å§ç¹ y
     * @param {number} x2 ç»æç¹ x
     * @param {number} y2 ç»æç¹ y
     * @return {object} åå´çå¯¹è±¡
     */
    box: function (x1, y1, x2, y2) {
        return getBBoxByArray([x1, x2], [y1, y2]);
    },
    /**
     * çº¿æ®µçé¿åº¦
     * @param {number} x1 èµ·å§ç¹ x
     * @param {number} y1 èµ·å§ç¹ y
     * @param {number} x2 ç»æç¹ x
     * @param {number} y2 ç»æç¹ y
     * @return {number} è·ç¦»
     */
    length: function (x1, y1, x2, y2) {
        return distance(x1, y1, x2, y2);
    },
    /**
     * æ ¹æ®æ¯ä¾è·åç¹
     * @param {number} x1 èµ·å§ç¹ x
     * @param {number} y1 èµ·å§ç¹ y
     * @param {number} x2 ç»æç¹ x
     * @param {number} y2 ç»æç¹ y
     * @param {number} t æå®æ¯ä¾
     * @return {object} åå« x, y çç¹
     */
    pointAt: function (x1, y1, x2, y2, t) {
        return {
            x: (1 - t) * x1 + t * x2,
            y: (1 - t) * y1 + t * y2,
        };
    },
    /**
     * ç¹å°çº¿æ®µçè·ç¦»
     * @param {number} x1 èµ·å§ç¹ x
     * @param {number} y1 èµ·å§ç¹ y
     * @param {number} x2 ç»æç¹ x
     * @param {number} y2 ç»æç¹ y
     * @param {number} x  æµè¯ç¹ x
     * @param {number} y  æµè¯ç¹ y
     * @return {number} è·ç¦»
     */
    pointDistance: function (x1, y1, x2, y2, x, y) {
        // æå½±è·ç¦» x1, y1 çåéï¼åè®¾ p, p1, p2 ä¸ä¸ªç¹ï¼æå½±ç¹ä¸º a
        // p1a = p1p.p1p2/|p1p2| * (p1p çåä½åé)
        var cross = (x2 - x1) * (x - x1) + (y2 - y1) * (y - y1);
        if (cross < 0) {
            return distance(x1, y1, x, y);
        }
        var lengthSquare = (x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1);
        if (cross > lengthSquare) {
            return distance(x2, y2, x, y);
        }
        return this.pointToLine(x1, y1, x2, y2, x, y);
    },
    /**
     * ç¹å°ç´çº¿çè·ç¦»ï¼èä¸æ¯ç¹å°çº¿æ®µçè·ç¦»
     * @param {number} x1 èµ·å§ç¹ x
     * @param {number} y1 èµ·å§ç¹ y
     * @param {number} x2 ç»æç¹ x
     * @param {number} y2 ç»æç¹ y
     * @param {number} x  æµè¯ç¹ x
     * @param {number} y  æµè¯ç¹ y
     * @return {number} è·ç¦»
     */
    pointToLine: function (x1, y1, x2, y2, x, y) {
        var d = [x2 - x1, y2 - y1];
        // å¦æç«¯ç¹ç¸ç­ï¼åå¤å®ç¹å°ç¹çè·ç¦»
        if (vec2.exactEquals(d, [0, 0])) {
            return Math.sqrt((x - x1) * (x - x1) + (y - y1) * (y - y1));
        }
        var u = [-d[1], d[0]];
        vec2.normalize(u, u);
        var a = [x - x1, y - y1];
        return Math.abs(vec2.dot(a, u));
    },
    /**
     * çº¿æ®µçè§åº¦
     * @param {number} x1 èµ·å§ç¹ x
     * @param {number} y1 èµ·å§ç¹ y
     * @param {number} x2 ç»æç¹ x
     * @param {number} y2 ç»æç¹ y
     * @return {number} å¯¼æ°
     */
    tangentAngle: function (x1, y1, x2, y2) {
        return Math.atan2(y2 - y1, x2 - x1);
    },
};
//# sourceMappingURL=line.js.map